export default "__VITE_ASSET__DLJ8osPL__"